import { render, staticRenderFns } from "./CargoTransKind.vue?vue&type=template&id=b8ea5d90&"
import script from "./CargoTransKind.vue?vue&type=script&lang=js&"
export * from "./CargoTransKind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports